export default "__VITE_ASSET__CG3$tm5Y__"